module.exports = __webpack_public_path__ + "img/bg_news.9a6f3fae.jpg";